module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/btn_3_pc_00eb77d716c85bf09cbc4a435f99c18c.png";